import { createReducerFromMap, createAsyncReducer, createDefaultInitialState } from "@coverme/redux";

const initialState = createDefaultInitialState([]);

const selectReducer = (state, { value }) => {
    return [value];
};

export const selectedProgramsReducer = createReducerFromMap(initialState, {
    ...createAsyncReducer("SELECT_PROGRAM", selectReducer),
});
